module.exports = __webpack_public_path__ + "img/icon-sti-sti-dest-hal.7652b3ca.svg";